<div class="d-flex justify-content-end user-info-sidebar px-md-4 pt-md-5 pb-2">
  <div class="d-flex align-items-center">
    @if (isLoggedIn) {
      <div routerLink="/manageAlerts/alerts" class="alerts-link d-none d-md-block" id="btn-manage-alerts">
        <div class="d-flex align-items-center justify-content-end">
          <i class="icon-edponline-Bra-030 font-size-32"></i>
          @if (notificationsCounter > 0) {
            <div class="notification-counter text-white font-size-11 d-flex align-items-center justify-content-center">
              {{ notificationsCounter }}
            </div>
          }
        </div>
      </div>
    }

    @if (!isLoggedIn) {
      <div (click)="openDialogLogin()" class="alerts-link d-none d-md-block" id="btn-manage-alerts">
        <div class="d-flex align-items-center justify-content-end">
          <i class="icon-edponline-Bra-030 font-size-32"></i>
          @if (notificationsCounter > 0) {
            <div class="notification-counter text-white font-size-11 d-flex align-items-center justify-content-center">
              {{ notificationsCounter }}
            </div>
          }
        </div>
      </div>
    }
  </div>
</div>
